import React from 'react'
import { Modal, Alert } from 'antd';

const ModalClosed = (props) => {
    const [isModalOpen, setIsModalOpen] = React.useState(true);
    const handleCancel = () => {
        setIsModalOpen(false);
        props.onClose();
    };
    const text = <p style={{
        fontSize: "14px",
        marginTop: "0px"
    }}>Mohon Maaf Layanan SIVIKI ( antar muka ) saat ini tidak tersedia.
        Silahkan dapat menghubungi kembali pada Hari Senin - Kamis pukul 08.00 - 16.00 WIB dan pada Hari Jumat pukul 08.00 - 16.30 WIB <br /><br /> Terimakasih</p>

    return (
        <Modal title=""
            open={isModalOpen}
            footer={null}
            onCancel={handleCancel}
        // closable={false}
        >
            <div style={{ textAlign: "center" }}>
                <div>
                    <img src={`siviki logo.png`} alt="Logo" width={100} />
                </div>
                {/* <Avatar size={64} icon={<VideoCameraOutlined style={{ color: "#fff" }} />} style={{ background: "red" }} /> */}

                <Alert description={text}
                    type="info"
                    showIcon
                />
            </div>
        </Modal>
    )
}

export default ModalClosed;